export default __webpack_public_path__ + "static/client_expectations-779393499b2aef7850f71ef40bc11df3.webp";